import Avatar from '@mui/material/Avatar';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useTranslation } from 'react-i18next';
import AppMenuContent from '../../AppMenuContent';
import { forceLogout } from '../../utils/authSession';

function userEmail() {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem('Email') || '' : '';
  } catch {
    return '';
  }
}

function userRoleLabel(role, t) {
  if (role === 'SUPER_ADMIN') return t('roles.superAdmin');
  if (role === 'ADMIN') return t('roles.admin');
  if (role === 'MERCHANT') return t('roles.merchant');
  if (role === 'OPERATOR') return t('roles.operator');
  if (role === 'TECHNICIAN') return t('roles.technician');
  return role || '—';
}

function SideMenuMobile({ open, toggleDrawer }) {
  const { t } = useTranslation();
  const email = userEmail();
  const role = typeof localStorage !== 'undefined' ? localStorage.getItem('role') || '' : '';
  const roleLabel = userRoleLabel(role, t);
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              sx={{ width: 24, height: 24, bgcolor: 'primary.main' }}
            >
              {email ? email.charAt(0).toUpperCase() : '?'}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography component="p" variant="subtitle2" noWrap>
                {roleLabel}
              </Typography>
              <Typography variant="caption" color="text.secondary" noWrap display="block">
                {email || t('common.user')}
              </Typography>
            </Box>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1, overflow: 'auto' }}>
          <AppMenuContent onNavigate={toggleDrawer(false)} />
          <Divider />
        </Stack>
        <Stack sx={{ p: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={() => {
              toggleDrawer(false)();
              forceLogout('user_menu_mobile');
            }}
          >
            {t('userMenu.logout')}
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
